export function sendPushNotification({ title, body, url }: { title: string; body: string; url?: string }) {
  if ("Notification" in window && Notification.permission === "granted") {
    (() => {
      const notification = new Notification(title, { body });
      if (url) {
        notification.onclick = function (event) {
          event.preventDefault();
          window.open(url, "_blank");
        };
      }
    })();
  }
}
